import {getDynamicPages} from '@/services/content/appContent';
import type {DynamicPageSectionModel} from '@/types/content';
import {DYNAMIC_PAGE_SECTION_TYPES} from '@/types/content';
import arrayUtils from '@/utils/arrayUtils';
import {twx} from '@/utils/tailwindUtils';

import BadgesCollectionSection from '@/views/BadgesCollectionSection/BadgesCollectionSection';
import BadgesInProgressCollectionSection from '@/views/BadgesInProgressCollectionSection/BadgesInProgressCollectionSection';
import BadgesInProgressSection from '@/views/BadgesInProgressSection/BadgesInProgressSection';
import HeaderSection from '@/views/HeaderSection/HeaderSection';

import DynamicPageSection from './DynamicPageSection';

type DynamicPageProps = {
    pageId: string;
    className?: string;
};

const renderSection = (section: DynamicPageSectionModel, index: number) => {
    const {type, id} = section;
    const key = `${type}-${index}`;

    switch (type) {
        case DYNAMIC_PAGE_SECTION_TYPES.HEADER:
            return (
                <DynamicPageSection key={key} id={id}>
                    <HeaderSection content={section.content} />
                </DynamicPageSection>
            );

        case DYNAMIC_PAGE_SECTION_TYPES.BADGES_IN_PROGRESS:
            return (
                <DynamicPageSection key={key} id={id}>
                    <BadgesInProgressSection content={section.content} />
                </DynamicPageSection>
            );

        case DYNAMIC_PAGE_SECTION_TYPES.BADGES_COLLECTION:
            return (
                <DynamicPageSection key={key} id={id}>
                    <BadgesCollectionSection />
                </DynamicPageSection>
            );

        case DYNAMIC_PAGE_SECTION_TYPES.BADGES_IN_PROGRESS_COLLECTION:
            return (
                <DynamicPageSection key={key} id={id}>
                    <BadgesInProgressCollectionSection content={section.content} />
                </DynamicPageSection>
            );

        default:
            return null;
    }
};

const DynamicPage = ({pageId, className}: DynamicPageProps) => {
    const page = getDynamicPages().find((p) => p.id === pageId);
    if (!page) return null;

    const sections = arrayUtils.sortArrayWithOrderField(page.pageSections ?? []);

    return (
        <div className={twx('flex min-h-full w-full flex-col gap-2 bg-tnemec-black px-4 pt-4 text-romance', className)}>
            {sections?.map(renderSection)}
        </div>
    );
};

export default DynamicPage;
